import script from "./GetInvolvedView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetInvolvedView.vue?vue&type=script&setup=true&lang=ts"

import "./GetInvolvedView.vue?vue&type=style&index=0&id=4f97d468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f97d468"]])

export default __exports__